import * as React from 'react';
import { useSelector } from 'react-redux';

import { useTheme } from '../../../../../theme';
import { getOrder, getTravellers, getEveryPortServicesToRefund } from '../../../../../Checkout/store/order/selectors';
import NasRefundServices from '../../../../../NasRefundServices/NasRefundServices';

interface Props {
	onCancel: () => void;
	reloadOrder: () => void;
}

const AirportServices: React.FC<Props> = props => {
	const theme = useTheme('Exchange').AirportServices;

	const order = useSelector(getOrder);
	const travellersToRefund = useSelector(getTravellers);
	const nasServicesToRefund = useSelector(getEveryPortServicesToRefund);

	const onSuccessfulRefund = () => {
		props.reloadOrder();
	};

	return (
		<div className={theme.wrapper}>
			<NasRefundServices
				services={nasServicesToRefund.map(selected => selected.product)}
				selectedServices={nasServicesToRefund}
				onSuccessfullyRefunded={onSuccessfulRefund}
				onCancel={props.onCancel}
				order={order}
				travellersToRefund={travellersToRefund.map(traveller => traveller.id)}
			/>
		</div>
	);
};

export default AirportServices;
